import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../../auth/auth.guard';
import { MasterResolver } from '../master/master.resolver';

import { EnvasadosComponent } from './envasados.component';
import { EnvasadoNoSelectedComponent } from './envasado-no-selected/envasado-no-selected.component';
import { EnvasadoEditComponent } from './envasado-edit/envasado-edit.component';
import { EnvasadoDetailsComponent } from './envasado-details/envasado-details.component';
import { BusinessGuard } from 'src/app/auth/business.guard';

const routes: Routes = [
  {
    path: ':business',
    data: { breadcrumb: 'business' },
    children: [
      {
        path: 'envasados',
        component: EnvasadosComponent,
        canActivate: [AuthGuard, BusinessGuard],
        resolve: [MasterResolver],
        data: { breadcrumb: 'Envasados' },
        children: [
          { path: '', component: EnvasadoNoSelectedComponent },
          {
            path: 'new',
            component: EnvasadoEditComponent,
            data: { breadcrumb: 'Nuevo' },
          },
          {
            path: ':id',
            component: EnvasadoDetailsComponent,
            data: { breadcrumb: 'Detalle' },
          },
          {
            path: ':id/edit',
            component: EnvasadoEditComponent,
            data: { breadcrumb: 'Editar' },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EnvasadosRoutingModule {}
